import { render, staticRenderFns } from "./Input.token.vue?vue&type=template&id=2061339c&"
import script from "./Input.token.vue?vue&type=script&lang=ts&"
export * from "./Input.token.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports